__turbopack_context__.v({
  "paragraph": "Error-module__io4qqa__paragraph",
  "wrapper": "Error-module__io4qqa__wrapper",
});
